import FormCreator from "../../components/forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { useEffect, useRef, useState } from "react";
import { resetpasswordData } from "./data/ResetPasswordForm.data";
import { useForgotPasswordMemberMutation } from "../../app/services/AdmissionBoardApproval/AdmissionBoardServiceApi";
import SwalAlert from "../../services/swalService/SwalService";
import { AppIcons } from "../../data/appIcons";
import Image from "../../components/ui/image/Image";

const ResetPasswordForm = () => {
  const resetFormRef = useRef();
  const [formData, setFormData] = useState(resetpasswordData);
  const { error, success } = SwalAlert();
  const [
    resetpass,
    { isLoading: isLoading, isSuccess: isSuccess, data: resetPasswordResponse },
  ] = useForgotPasswordMemberMutation();

  useEffect(() => {
    if (!isLoading && isSuccess && resetPasswordResponse) {
      success(
        " An email with a password reset link has been sent to your registered email address. Please follow the provided instructions."
      );
    }
  }, [isLoading, isSuccess, resetPasswordResponse]);

  const handleResetPasswordSentLink = () => {
    const formData = resetFormRef.current?.getFormData();
    if (!formData) return;
    const request = {
      Email: formData?.emailAddress || null,
      IsForCommittee: 1
    };
    resetpass(request);
  };

  return (
    <div className="login-application">
      <div className="login-page">
        {/* <div className="login-page-logo">
          <Image
            imagePath={AppIcons.logoImage}
            imgCustomClassName="open-bar"
            altText="Icon"
          ></Image>
        </div> */}
        <div className="login-form-section">
          <h1>Reset Password</h1>
          <p className="sub-heading">
            Enter the Email to retrieve your account
          </p>
          <form>
            <div className="form-data">
              <FormCreator config={formData} ref={resetFormRef} />
            </div>
          </form>
          <div className="btn-part">
            <Buttons
              buttonTypeClassName="btn theme-btn"
              buttonText="Reset Your Password"
              onClick={handleResetPasswordSentLink}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
